import { CoinAmount, type IPrepareData } from '@/types'

interface InterfaceEthereumPrepareData {
  gasPrice: {
    high: string
    medium: string
    low: string
  }
  gasLimit: number
  nonce: number
  decimal: number
  feeType?: string // V2: 'fixed-fee' 등
}

export class EthereumPrepareData implements IPrepareData {
  public gasPrice: {
    high: CoinAmount
    medium: CoinAmount
    low: CoinAmount
  }
  public gasLimit: number
  public nonce: number
  public feeType?: string // V2: 'fixed-fee' 등

  constructor(data: InterfaceEthereumPrepareData) {
    this.gasPrice = {
      high: new CoinAmount({
        amount: data.gasPrice.high,
        decimal: data.decimal,
      }),
      medium: new CoinAmount({
        amount: data.gasPrice.medium,
        decimal: data.decimal,
      }),
      low: new CoinAmount({
        amount: data.gasPrice.low,
        decimal: data.decimal,
      }),
    }
    this.gasLimit = data.gasLimit
    this.nonce = data.nonce
    this.feeType = data.feeType
  }
}
